<div class="bc-language-selector"
     appMenuFocusHandler
     #focusHandler="menuFocusHandler">
  <button appMenuFocusParent
          class="link-item header-menu-link"
          [tabindex]="this.isFocusable | appIsFocusableTabIndex">
    <span>{{ 'languageSelector.language' | translate }}</span>
    <svg-icon class="icon-after" icon="arrow-right"></svg-icon>
  </button>

  <div class="menu-hover js-language-list">
    <ul class="link-list">
      <li *ngFor="let language of languages">
        <button id="{{language.name}}"
                class="link-item"
                appMenuFocusTarget
                [focusHandler]="focusHandler"
                [tabindex]="focusHandler.isFocusable | appIsFocusableTabIndex"
                [ngClass]="{ 'selected': language.name === currentLanguage }"
                (click)="setLanguage(language)">
          <span>{{ language.name }}</span>
          <svg-icon icon="checkmark" class="icon-tail" *ngIf="language.name === currentLanguage"></svg-icon>
        </button>
      </li>
    </ul>
  </div>
</div>
